// sticky mobile nav

document.querySelector("#hamburger").addEventListener("click", function () {
  event.preventDefault();
  const toggleWrapper = document.querySelector(".mobile-toggle-wrapper");
  if (toggleWrapper) {
    console.log("enter");
    toggleWrapper.classList.toggle("active");
    if (toggleWrapper.hasAttribute("open")) {
      toggleWrapper.removeAttribute("open");
    } else {
      toggleWrapper.setAttribute("open", "true");
    }
  }
});

// Kwikpass changes
  function autoLogin (){
        // document.getElementById('kwik-pass-text').textContent = "My Account";
        document.getElementById('kp-account').classList.remove('kwik-pass-login');
        document.getElementById('kp-account').classList.add('kwik-pass-account');
        document.getElementsByClassName('kwik-pass-account')[0].addEventListener('click', function(e){
          handleShopifyLogin(e,"/account")
        });
      }
      window.addEventListener('user-loggedin', function(event) {
         const { token } = event?.detail;
         if (token){
           autoLogin();
         }
      });
    document.addEventListener('DOMContentLoaded',function () {
      var userToken = localStorage.getItem('KWIKSESSIONTOKEN');
      if (userToken){
        autoLogin();
      }
  })

